export const StorageKeys = {
  accessToken: 'archive_access_token',
  currentUser: 'archive_current_user',
  language: 'archive_language'
};
